import { render } from "./FrontendFooterComponent.vue?vue&type=template&id=5ff1b8b8"
import script from "./FrontendFooterComponent.vue?vue&type=script&lang=js"
export * from "./FrontendFooterComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/layouts/frontend/FrontendFooterComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5ff1b8b8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5ff1b8b8', __exports__)) {
    api.reload('5ff1b8b8', __exports__)
  }
  
  module.hot.accept("./FrontendFooterComponent.vue?vue&type=template&id=5ff1b8b8", () => {
    api.rerender('5ff1b8b8', render)
  })

}


export default __exports__